import React, { useState, useEffect } from "react";
import BallotIcon from "@mui/icons-material/Ballot";
import AddIcon from "@mui/icons-material/Add";
import Pagination from "../../components/Pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import loader from "../../assets/loader.webp";
import AddCategory from "./AddCategory";
import EditCategory from "./EditCategory";
import ConfirmModal from "../../components/ConfirmModal";
import { fetchData, deleteData, getDataById } from "../../utility/adminApi";
import SingleCategoryDetails from "./SingleCategoryDetails";
import AddSubcategory from "./AddSubcategory";
import { useNavigate } from "react-router";

function Category() {
  const [categoryData, setCategoryData] = useState([]);
  const [, setSubcategoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addtab, setAddtab] = useState(false);
  const [addSubtab, setAddSubtab] = useState(false);
  const [edittab, setEdittab] = useState(false);
  const [viewTab, setViewTab] = useState(false);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [singleData, setSingleData] = useState({});
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchCategories = async (page = 1, search = "") => {
    const response = await fetchData("categories", currentPage, searchData);
    setCategoryData(response?.data?.data);

    setTotalPage(response?.data?.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  const fetchSubcategories = async (page) => {
    const response = await fetchData("sub_categories", currentPage, searchData);
    setSubcategoryData(response?.data?.data || []);

    setTotalPage(response?.data?.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  useEffect(() => {
    fetchCategories(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    fetchCategories(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  const handleCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleAdd = () => {
    setAddtab(true);
    setEdittab(false);
  };

  const handleAddSubCategory = () => {
    // setAddSubtab(true);
    setEdittab(false);
    navigate("/admin/subcategory")
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("categories/show/", id);
    setSingleData(response?.data?.data);
    if (setEditTab) {
      setEdittab(true);
    } else {
      setViewTab(true);
    }
  };

  const handleDelete = (id) => {
    setCompanyIdToDelete(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    await deleteData("categories/delete/", companyIdToDelete);
    fetchCategories(currentPage); //
    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col space-y-6">
      <div className="flex lg:overflow-y-hidden ">
        {/* Header */}

        <div className="flex flex-col gap-4 w-full ">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              {" "}
              <BallotIcon />
              <h3 className="text-2xl font-semibold">
                {!viewTab ? "My Store" : singleData.cat_name}
              </h3>
            </div>

            <div className="flex flex-row gap-4 flex-wrap">
              <button
                onClick={() => {
                  // Placeholder for generating store logic
                  alert("Generate Store functionality coming soon!");
                }}
                className="px-4 py-3 text-white rounded-lg bg-green-600"
              >
                Generate Store
              </button>
              <button
                onClick={() => {
                  handleAdd();
                }}
                className="px-4 py-3 text-white rounded-lg bg-blue-500"
              >
                New Category <AddIcon />
              </button>
              <button
                onClick={handleAddSubCategory}
                className="px-4 py-3 text-white rounded-lg bg-purple-600"
              >
                Subcategory
              </button>
            </div>
          </div>
          {!addtab && !edittab && viewTab && (
            <SingleCategoryDetails
              setIsLoading={setIsLoading}
              setViewTab={setViewTab}
              data={singleData}
            />
          )}
          {addSubtab && !edittab && (
            <AddSubcategory
              setIsLoading={setIsLoading}
              setAddtab={setAddSubtab}
              fetchCategories={fetchSubcategories}
              currentPage={currentPage}
            />
            // <SubCategory />
          )}
          {addtab && !edittab && !viewTab && (
            <AddCategory
              setIsLoading={setIsLoading}
              setAddtab={setAddtab}
              fetchCategories={fetchCategories}
              currentPage={currentPage}
            />
          )}
          {edittab && !addtab && !viewTab && (
            <EditCategory
              singleData={singleData}
              setSingleData={setSingleData}
              setEdittab={setEdittab}
              setLoading={setIsLoading}
              currentPage={currentPage}
              fetchCategories={fetchCategories}
            />
          )}
          {!edittab && !addtab && !viewTab && (
            <div className=" bg-white flex flex-col lg:justify-normal w-full lg:gap-4 overflow-x-scroll items-center py-6 px-8">
              <div className="flex  w-full">
                <div className="flex gap-2">
                  {/* Consider resarching for MUI UI search bar  */}
                  <input
                    placeholder="Search for"
                    type="text"
                    name="cat_name"
                    // id="email"
                    value={searchData}
                    onChange={handleChange}
                    className="border-2 border-gray-400 w-60 p-2 px-6"
                  />
                </div>
              </div>

              <div className="w-full">
                {isLoading ? (
                  <div className="  flex justify-center items-center">
                    {" "}
                    <img
                      src={loader}
                      alt="loader"
                      className=" w-10 lg:w-20 "
                    />{" "}
                  </div>
                ) : (
                  <table className="min-w-full bg-white border border-gray-300">
                    <thead>
                      <tr className="bg-gray-200">
                        <th className="py-2 px-4 border-b border-gray-300">
                          CATEGORY
                        </th>
                        {/* <th className="py-2 px-4 border-b border-gray-300">
                          SUB CATEGORY
                        </th> */}

                        <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                          ACTIONS
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {categoryData?.map((item) => (
                        <tr
                          key={item?.id}
                          className="hover:bg-gray-100 border-b border-gray-300"
                        >
                          <td className="py-2 px-4 text-center text-wrap">
                            {item?.cat_name}
                          </td>
                          {/* <td className="py-2 px-4 text-center text-wrap flex gap-2 justify-center">
                            {item?.sub_categories?.map((sub) => (
                              <h4 key={sub.id}>
                                {""}
                                {sub?.sub_cat_name || "N/A"}
                              </h4>
                            ))}
                          </td> */}

                          <td className="py-2 px-4 text-center justify-center flex gap-3">
                            <EditIcon
                              onClick={() => handleSingleFile(item?.id, true)}
                              className="text-blue-500 cursor-pointer"
                            />
                            <VisibilityIcon
                              onClick={() => handleSingleFile(item?.id)}
                              className="text-yellow-400 cursor-pointer"
                            />
                            <DeleteIcon
                              onClick={() => handleDelete(item?.id)}
                              className="text-red-500 cursor-pointer"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                <Pagination
                  onPageChange={handleCurrentPage}
                  totalPage={totalPage}
                  currentPage={currentPage}
                  setIsNextLoading={setIsNextLoading}
                  setIsPrevLoading={setIsPrevLoading}
                  isPrevLoading={isPrevLoading}
                  isNextLoading={isNextLoading}
                />
              </div>
            </div>
          )}
        </div>
        <ConfirmModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirmDelete}
          text1="Confirm Delete"
          text2="Are you sure you want to delete the category?"
        />

      </div>
      {/* <SubCategory /> */}
    </div>
  );
}

export default Category;
